module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/top-trainers-750.1d03f8d3ed8b6bbf.jpg"+" 750w",
        images: [{path: "https://static.sniffspot.com/packs/img/top-trainers-750.1d03f8d3ed8b6bbf.jpg",width: 750,height: 600}],
        src: "https://static.sniffspot.com/packs/img/top-trainers-750.1d03f8d3ed8b6bbf.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/top-trainers-750.1d03f8d3ed8b6bbf.jpg"},
        
        width: 750,
        height: 600
      }